.modal {
  height: 800px;
  max-height: 95%;
  min-width: 950px;
  width: 950px;

  @media (--reefer-media-desktop-sm-max) {
    min-width: unset;
    width: 100%;
  }

  @media (--reefer-media-tablet-max) {
    border-radius: 0;
    height: 100%;
    max-height: 100%;
    max-width: 100%;
    /* stylelint-disable-next-line declaration-no-important -- overrides Reefer Modal inline styles */
    top: 0 !important;
    /* stylelint-disable-next-line declaration-no-important -- overrides Reefer Modal inline styles */
    transform: translateX(-50%) !important;
    width: 100%;
  }
}

.logoPill {
  background: var(--wizard-header-color);
  border-radius: 100px;
  left: 50%;
  max-height: 40px;
  padding: 10px 16px;
  position: absolute;
  transform: translateX(-50%);
}

.icon {
  padding: 0;
}

.logoImage {
  max-height: 20px;
  max-width: 62px;
  object-fit: contain;
}

.headerActions {
  margin-left: auto;
  margin-right: 16px;
  position: relative;

  @media (--reefer-media-tablet-max) {
    margin-right: 0;
  }
}

.footer {
  display: flex;
  padding: 8px;

  @media (--reefer-media-tablet-max) {
    display: none;
  }
}

.inlineFooter {
  display: none;
  padding: 16px 0;

  @media (--reefer-media-tablet-max) {
    display: block;
  }
}

.footerLogo > div {
  color: var(--colors-grays-mid);
  height: 16px;
  width: 61px;
}

.footerLogo svg path:last-child {
  fill: currentcolor;
}

.welcomeDescription {
  max-width: 570px;
}

.getStartedButton {
  width: 250px;
}
